import { Component } from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import { Storage } from '@ionic/storage';
import 'leaflet';
import * as moment from 'moment';
import {MainPage} from "../main/main";
import {HistoricPage} from "../historic/historic";
import {SocketService} from "../../services/socket.service";
import {UtilsService} from "../../services/utils.service";
import {AssetsService} from "../../services/assets.service";
import {SensorUtilService} from "../../services/sensors.service";
import {LoginPage} from "../login/login";
import {AuthService} from "../../services/auth.service";
import {GlobalVariable} from "../../services/global.vars";

@Component({
  selector: 'page-realtime',
  templateUrl: 'realtime.html'
})
export class RealtimePage{
  private asset: any = {};
  private map: any;
  private zoom: number = 15;
  private marker:any;
  private canGoBack:boolean = false;
  private baseLayers: any;
  private baseLayersKeys:any = [];

  constructor(public navCtrl: NavController,
              private socketService: SocketService,
              private utilsService: UtilsService,
              private assetsService: AssetsService,
              private storage: Storage,
              private sensorUtilService: SensorUtilService,
              private authService:AuthService,
              public navParams: NavParams) {
    //Getting the asset object from navigation parameters
    this.asset = navParams.get('asset');
    this.canGoBack = navParams.get('canGoBack');

  }

  private selectedBaseLayerKey: string;
  private HIDE_DISPUTED_BOUNDARIES=GlobalVariable.HIDE_DISPUTEDBOUNDARIES?"&apistyle=s.t:17|s.e:all|p.v:off":"";

  public baseLayer : any = {
    NGI: L.tileLayer.wms(GlobalVariable.TILE_URL, {
      maxZoom: 19,
      name: "NGI",
      attribution: 'Powered iaxeed',
      icon: 'ngiMap.png'
    }),
    googleRoadmap: L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}'+this.HIDE_DISPUTED_BOUNDARIES, {
      maxZoom: 19,
      name: "Google Map",
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      icon: 'gNorm.png'

    }),

    googleTerrain: L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}'+this.HIDE_DISPUTED_BOUNDARIES, {
      maxZoom: 19,
      name: "Google Satellite",
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      icon: 'gSat.png'

    }),
    googleHybrid: L.tileLayer('http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}'+this.HIDE_DISPUTED_BOUNDARIES, {
      maxZoom: 19,
      name: "Google Hybride",
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      icon: 'gHybr.png'

    }),
    osm: L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      name: "Open Street",
      icon: 'osmMap.png'

    })
  };

  initMap(){
    this.map.options.attributionControl = true;
    this.map.attributionControl.setPrefix('');
    this.map.whenReady(()=>{
      this.storage.ready().then(()=>{
        this.storage.get('baselayer').then((baselayer)=>{
          this.changeBaseLayer(baselayer);
        })
      })
    })
  }

  changeBaseLayer(key) {
    for (let k in this.baseLayer) {
      if (this.map.hasLayer(this.baseLayer[k])){
        this.map.removeLayer(this.baseLayer[k]);
      }
    }

    this.storage.ready().then(()=>{
      this.storage.set('baselayer', key).then(()=>{
        this.storage.get('baselayer').then((bLayer)=>{
          this.selectedBaseLayerKey = bLayer;
          this.map.addLayer(this.baseLayer[bLayer]);
        })
      });
    });

  };


  ngOnInit() {
    this.baseLayers = this.baseLayer;
    this.baseLayersKeys = Object.keys(this.baseLayers);
    this.map =  new L.Map('mapRT', {
      center : [this.asset.rt.loc.coordinates[1], this.asset.rt.loc.coordinates[0]],
      zoom: 14
    });
    this.initMap();

    this.loadMarker();

    this.map.on('zoomend', ()=>{
        this.map.panTo(new L.LatLng(this.asset.rt.loc.coordinates[1],this.asset.rt.loc.coordinates[0]));
    });

    this.socketService.on('newMsg').subscribe((data:any)=>{
      if(this.asset._id == data._id){
        this.map.removeLayer(this.marker);
        this.asset = data;
        let coordinates = [];
        let result = [];

        if (this.asset.rt && this.asset.rt.loc && this.asset.rt.loc.coordinates && this.asset.rt.loc.coordinates[1] && this.asset.rt.loc.coordinates[0]) {
          coordinates.push([this.asset.rt.loc.coordinates[0], this.asset.rt.loc.coordinates[1]])
        } else {
          coordinates.push([0, 0])
        }

        if (coordinates.length > 0){
          this.utilsService.getAddress(coordinates).subscribe(data => {
            let res = data.BND.BatchResults;

            if (res.length > 0) {
              for(let value of res){
                if (value.Elements.count > 0) {
                  let element = value.Elements.Element[0];
                  let address = this.utilsService.format(element);
                  result.push(address);
                }
                else
                  result.push("Not available")
              }
            }


            if (this.asset.rt && this.asset.rt.loc && this.asset.rt.loc.coordinates && this.asset.rt.loc.coordinates[1] && this.asset.rt.loc.coordinates[1] !== 0 && this.asset.rt.loc.coordinates[0] && this.asset.rt.loc.coordinates[0] !== 0)
              this.asset.address = result[0];
            this.getAssetSensors(this.asset);
            this.asset = this.assetsService.getSingleAssetIcons(this.asset);
            this.loadMarker();

            this.map.setView([this.asset.rt.loc.coordinates[1],this.asset.rt.loc.coordinates[0]], this.zoom);
            this.map.panTo(new L.LatLng(this.asset.rt.loc.coordinates[1],this.asset.rt.loc.coordinates[0]));
          });
        }

      }
    });


  }

  getAssetSensors(asset){
    let sensors = asset.sensors;
    asset.sensorData = [];
    if(sensors.length > 0){
      for(let sensor of sensors){
        let sensorName = sensor.name;
        let src = sensor.src.slice(sensor.src.lastIndexOf('.') + 1);
        if (sensor.type && sensor.src && asset.rt &&asset.rt.io && Number.isFinite(asset.rt.io[src])) {
          let realVal = asset.rt.io[src];
          if (this.sensorUtilService.getSensorFamily(sensor.type) === "ANALOGIC") {
            if (Number.isFinite(sensor.minSrc) && Number.isFinite(sensor.maxSrc) && Number.isFinite(sensor.min) && Number.isFinite(sensor.max)) {
              realVal = this.sensorUtilService.getRealSensorValue(asset.rt.io[src], sensor.minSrc, sensor.maxSrc, sensor.min, sensor.max, sensor.gaps, sensor);
            }
            if (Number.isFinite(realVal))
              asset.sensorData.push({
                name: sensorName,
                type: sensor.type,
                family: sensor.family,
                unit: sensor.unit,
                value: parseFloat(realVal.toFixed(2))
              });
          }
          if (this.sensorUtilService.getSensorFamily(sensor.type) === "BINARY") {
            asset.sensorData.push({
              name: sensorName,
              type: sensor.type,
              family: sensor.family,
              ON: sensor.ON,
              OFF: sensor.OFF,
              value:realVal,
              status: realVal === sensor.ON ? this.sensorUtilService.getSensorsTypes().STATUS[sensor.type].enabled
              :  this.sensorUtilService.getSensorsTypes().STATUS[sensor.type].disabled,
              class: realVal === sensor.ON ? "is-on" : "is-off"
            });
          }
        }
      }
    }
  }

  loadMarker(){

    let odometer: number = 0;

    if(this.asset.rt) {
      let data = {
        name: "",
        family: "",
        date: "",
        spd: "",
        ang: 0,
        odo: "",
        lng: 0,
        lat: 0,
        con: 0,
        gps_dt: null,
        address: ""
      };

      data.name = this.asset.name;

      if (this.asset.family) {
        data.family = this.asset.family;
      }
      if(this.asset.sensors.length > 0){

        let sensors = this.asset.sensors;
        if (sensors.length > 0) {
          for (let sensor of sensors) {
            let src = sensor.src.slice(sensor.src.lastIndexOf('.') + 1);
            if (sensor.type && sensor.type === "ODOMETER" && sensor.src && Number.isFinite(this.asset.rt.io[src])) {
              let realVal = this.asset.rt.io[src];
              if (Number.isFinite(sensor.minSrc) && Number.isFinite(sensor.maxSrc) && Number.isFinite(sensor.min) && Number.isFinite(sensor.max)) {
                realVal = this.sensorUtilService.getRealSensorValue(this.asset.rt.io[src], sensor.minSrc, sensor.maxSrc, sensor.min, sensor.max, sensor.gaps, sensor);
              }
              if (Number.isFinite(realVal)) {
                odometer = parseFloat(realVal.toFixed(2));
              }
            }
          }
        }
      }

      if (this.asset.rt.gps_dt) {
        data.gps_dt = moment(this.asset.rt.gps_dt);
      }
      if (odometer)
        data.odo = odometer.toString();
      else if (this.asset.rt.odo) {
        data.odo = Math.round(this.asset.rt.odo).toFixed(1);
      }

      if (this.asset.rt.io) {
        if (this.asset.rt.io.spd) {
          data.spd = this.asset.rt.io.spd;
        }
        if (this.asset.rt.io.ang) {
          data.ang = this.asset.rt.io.ang;
        }
        if (this.asset.rt.io.con) {
          data.con = this.asset.rt.io.con;
        }
      }

      if (this.asset.rt.loc) {
        if (this.asset.rt.loc.coordinates && this.asset.rt.loc.coordinates[1] && this.asset.rt.loc.coordinates[1] !== 0 && this.asset.rt.loc.coordinates[0] && this.asset.rt.loc.coordinates[0] !== 0) {
          data.lng = this.asset.rt.loc.coordinates[0];
          data.lat = this.asset.rt.loc.coordinates[1];
        }
      }

      if (this.asset.address) {
        data.address = this.asset.address;
      }

      if (data.lng !== 0 && data.lat !== 0) {
        let content = '<div class="map-popup"><div class="popup-heading fa fa-car"> ' + data.name + '</div><div class="popup-details">';
        if (data.gps_dt != null) {
          content += '<div  class="fa fa-clock-o"><b> Date</b></div> ' + moment(data.gps_dt).format('DD/MM/YYYY HH:mm:ss') + '<br/>';
        }
        if (data.spd !== "") {
          content += '<div  class="fa fa-tachometer"><b> Vitesse</b></div> ' + data.spd + ' km/h<br/>';
        }
        if (data.odo !== "") {
          content += '<div  class="fa fa-calculator"><b>Kilomètrage</b></div> ' + parseFloat(parseFloat(data.odo).toFixed(2).toString()) + ' km<br/>';
        }
        if (data.address !== "") {
          content += '<div  class="fa fa-map-marker"><b>Adresse</b></div> ' + data.address;
        }
        content += '</div>';

        let assetIcon = L.divIcon({
          html: '<img src="' + this.asset.icons.up + '" style="width: 30px; height: 62px;transform: rotate(' + data.ang + 'deg);  -webkit-transform: rotate(' + data.ang + 'deg); -moz-transform:rotate(' + data.ang + 'deg);" />',
          iconSize: [30, 62],
          iconAnchor: [6, 15]
        });

        this.marker = new L.Marker(new L.LatLng(data.lat, data.lng),
          {
            icon: assetIcon
          }).bindPopup(content);

        let label = "<span class='tooltip-name'>"+data.name+"</span>";
        if(data.spd != ""){
          label += "<br><span class='tooltip-speed'>"+ data.spd+ " Km/h</span>";
        }

        this.marker.addTo(this.map).bindTooltip(label, { direction:'right', permanent: true ,offset: [15, 0] ,className: 'tooltip-marker' });
      }
    }
  }

  goMain(){
    this.navCtrl.push(MainPage, {asset : this.asset, canGoBack: this.canGoBack}, {animate: true, direction: 'back'}).then(()=>{
      const index = this.navCtrl.getActive().index;
      this.navCtrl.remove(index-1);
    });
  }
  goHisto(){
    this.navCtrl.push(HistoricPage, {asset : this.asset, canGoBack: this.canGoBack}, {animate: true, direction: 'forward'}).then(()=>{
      const index = this.navCtrl.getActive().index;
      this.navCtrl.remove(index-1);
    });
  }

  goBack(){
    // Go back to assets
    if(this.canGoBack){
      this.navCtrl.pop();
    }
  }

  logout(){
    this.authService.disconnect().then(()=>{
      this.navCtrl.setRoot(LoginPage);
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/realtime/realtime.ts